import { render, staticRenderFns } from "./AboutLime.vue?vue&type=template&id=1845ed59&scoped=true"
import script from "./AboutLime.vue?vue&type=script&lang=js"
export * from "./AboutLime.vue?vue&type=script&lang=js"
import style0 from "./AboutLime.vue?vue&type=style&index=0&id=1845ed59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845ed59",
  null
  
)

export default component.exports